import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Board, Card, Responsible, Ticket } from '../../../backend/backendapi';
import { KanbanState } from '../../kanban.model';
import { getSharedInfoBoard } from '../../kanban.util';
import ActivityLogComponent from '../activityLog/activityLog.controller';
import AttributeDefinitionsModal from '../attributedefinitions/AttributeDefinitionsModal';
import DetailsModal from '../DetailsModal';
import PortModal from '../port/port.controller';
import ResponsibleModal from '../responsible/responsiblemodal.controller';
import ShareBoardModal from '../shareboard/shareboard.controller';
import LockdownModal from '../lockdown/lockdown.controller';
import BoardCreateModal from '../boardcreatemodal/boardcreatemodal.controller';
import ApprovalRequestModal from '../../approval/ApprovalRequestModal';
import ApprovalListModal from '../../approval/ApprovalListModal';
import MassSelectArchiveConfirmModal from '../massSelect/MassSelectArchiveConfirmModal';
import MassSelectDeleteConfirmModal from '../massSelect/MassSelectDeleteConfirmModal';
import MassSelectPdfConfirmModal from '../massSelect/MassSelectPdfConfirmModal';
import AssignedCardsModal from '../AssignedCardsModal';

@Component({
    name: 'ModalContainer',
    components: {
        ActivityLogModal: require('../activityLog/activityLog.vue.html').default,
        ApprovalListModal,
        ApprovalRequestModal,
        AssignedCardsModal,
        AttributeDefinitionsModal,
        BoardCreateModal: require('../boardcreatemodal/boardcreatemodal.vue.html').default,
        DetailsModal,
        LockdownDelayModal: require('../lockdown/lockdown.vue.html').default,
        MassSelectArchiveConfirmModal,
        MassSelectDeleteConfirmModal,
        MassSelectPdfConfirmModal,
        PortModal: require('../port/port.vue.html').default,
        ResponsibleModal: require('../responsible/responsiblemodal.vue.html').default,
        ShareBoardModal: require('../shareboard/shareboard.vue.html').default,
    },
})
export default class ModalContainer extends Vue {
    //external functions, see kanbanlist.util.ts
    getSharedInfoBoard = getSharedInfoBoard;

    @Prop({ required: true })
    readonly state!: KanbanState;
    @Prop({ required: true })
    readonly responsibles!: Responsible[]; //mass select responsible

    //runtime
    private board: Board | null = null;
    private flow: Ticket | null = null;
    private card: Card | null = null;
    private readonlyDetails: boolean = false;

    // ------------------------- list modals --------------------------------

    //share
    openBoardShare(board: Board): void {
        this.board = board;
        this.$nextTick(() => (this.$refs.shareboard as ShareBoardModal).openModal());
    }

    closeBoardShare(): void {
        (this.$refs.shareboard as ShareBoardModal)?.closeModal();
        this.$nextTick(() => this.board = this.flow = this.card = null);
    }

    //activity
    openActivityLog(): void {
        (this.$refs.activityLog as ActivityLogComponent).openModal();
    }

    closeActivityLog(): void {
        (this.$refs.activityLog as ActivityLogComponent)?.closeModal();
        this.$nextTick(() => this.board = this.flow = this.card = null);
    }

    //responsible
    openResponsible(): void {
        (this.$refs.responsibleMassselect as ResponsibleModal).open();
    }

    closeResponsible(): void {
        (this.$refs.responsibleMassselect as ResponsibleModal)?.dismiss();
        this.$nextTick(() => this.board = this.flow = this.card = null);
    }

    //attribute definitions
    openAttributeDefinitions(board: Board): void {
        this.board = board;
        this.$nextTick(() => (this.$refs.attributeDefinitionsModal as AttributeDefinitionsModal).open());
    }

    closeAttributeDefinitions(): void {
        (this.$refs.attributeDefinitionsModal as AttributeDefinitionsModal)?.dismiss();
        this.$nextTick(() => this.board = this.flow = this.card = null);
    }

    //lockdown delay
    openLockdownDelay(board: Board): void {
        this.board = board;
        this.$nextTick(() => (this.$refs.lockdownDelayModal as LockdownModal).open());
    }

    closeLockdownDelay(): void {
        (this.$refs.lockdownDelayModal as LockdownModal)?.dismiss();
        this.$nextTick(() => this.board = this.flow = this.card = null);
    }

    //board create
    openBoardCreateModal(name: string): void {
        this.$nextTick(() => (this.$refs.boardCreateModal as BoardCreateModal).open(name));
    }

    closeBoardCreateModal(): void {
        (this.$refs.boardCreateModal as BoardCreateModal)?.dismiss();
        this.$nextTick(() => this.board = this.flow = this.card = null);
    }

    getBoardCreateModal(): BoardCreateModal | undefined {
        return this.$refs.boardCreateModal as BoardCreateModal;
    }

    //approvals
    openRequestApproval(): void {
        (this.$refs.approvalRequest as ApprovalRequestModal).open();
    }

    closeRequestApprovals(): void {
        (this.$refs.approvalRequest as ApprovalRequestModal)?.dismiss();
        this.$nextTick(() => this.board = this.flow = this.card = null);
    }

    openListApprovals(): void {
        (this.$refs.approvalList as ApprovalListModal).open();
    }

    closeListApprovals(): void {
        (this.$refs.approvalList as ApprovalListModal)?.dismiss();
        this.$nextTick(() => this.board = this.flow = this.card = null);
    }

    //mass select archive
    openAssignedCards(): void {
        (this.$refs.assignedCards as AssignedCardsModal).open();
    }

    closeAssignedCards(): void {
        (this.$refs.assignedCards as AssignedCardsModal).dismiss();
    }

    //mass select archive
    openConfirmMassSelectArchive(): void {
        (this.$refs.archiveMassselect as MassSelectArchiveConfirmModal).open();
    }

    closeConfirmMassSelectArchive(): void {
        (this.$refs.archiveMassselect as MassSelectArchiveConfirmModal)?.dismiss();
        this.$nextTick(() => this.board = this.flow = this.card = null);
    }
    
    //mass select delete
    openConfirmMassSelectDelete(): void {
        (this.$refs.deleteMassselect as MassSelectDeleteConfirmModal).open();
    }

    closeConfirmMassSelectDelete(): void {
        (this.$refs.deleteMassselect as MassSelectDeleteConfirmModal)?.dismiss();
        this.$nextTick(() => this.board = this.flow = this.card = null);
    }

    //mass select delete
    openConfirmMassSelectPdf(): void {
        (this.$refs.pdfMassselect as MassSelectPdfConfirmModal).open();
    }

    closeConfirmMassSelectPdf(): void {
        (this.$refs.pdfMassselect as MassSelectPdfConfirmModal)?.dismiss();
        this.$nextTick(() => this.board = this.flow = this.card = null);
    }

    // ------------------------- flow modals --------------------------------
    //port
    openPort(board: Board, flow: Ticket, card: Card): void {
        this.board = board;
        this.flow = flow;
        this.card = card;
        this.$nextTick(() => (this.$refs.portmodal as PortModal).openModal());
    }

    closePort(): void {
        (this.$refs.portmodal as PortModal)?.closeModal();
        this.$nextTick(() => this.board = this.flow = this.card = null);
    }

    private onPortClose(): void {
        setTimeout(() => this.board = this.flow = this.card = null, 100);
    }

    // ------------------------- card modals --------------------------------
    //details
    openDetails(board: Board, flow: Ticket, card: Card, readonly: boolean = false): void {
        this.board = board;
        this.flow = flow;
        this.card = card;
        this.readonlyDetails = readonly;
        this.$nextTick(() => (this.$refs.detailsmodal as DetailsModal).openModal());
    }

    closeDetails(): void {
        (this.$refs.detailsmodal as DetailsModal)?.closeModal();
        this.$nextTick(() => this.board = this.flow = this.card = null);
    }
}
